import { CreatorShopMembershipPaymentPage } from './CreatorShopMembershipPaymentPage';

export const creatorShopMembershipPaymentRouter = {
  '/membership/payment': CreatorShopMembershipPaymentPage,
};
